import { defineMessages } from 'react-intl'

const scope = `procurify.platform.iam.pages`

export default defineMessages({
  settingsTitle: {
    id: `${scope}.settingsTitle`,
    defaultMessage: 'Settings',
  },
  MFAPreferencesTitle: {
    id: `${scope}.MFAPreferencesTitle`,
    defaultMessage: 'Security and authentication: MFA',
  },
  ManageUsersTitle: {
    id: `${scope}.ManageUsersTitle`,
    defaultMessage: 'Manage users',
  },
  UserDetailsTitle: {
    id: `${scope}.UserDetailsTitle`,
    defaultMessage: 'User details',
  },
  settingsManageRolesPermissionsPageTitle: {
    id: `${scope}.settingsManageRolesPermissionsPageTitle`,
    defaultMessage: 'Manage roles & permissions',
  },
  manageDateFormatTitle: {
    id: `${scope}.manageDateFormatTitle`,
    defaultMessage: 'Manage organization',
  },
  reportAccessTitle: {
    id: `${scope}.reportAccessTitle`,
    defaultMessage: 'Reports access',
  },
})
